const routes = {
  UpdateCertificate:'/customers/certificates/update',
  CreateCertificate:'/hrms/certificates/add',
  getCandidateLists:'/customers/candidates',
  getCertificates:'/hrms/certificates',
  ServiceInvoiceDetail:'/customers/services/details',
  UpdateAddOnservice:'/customers/services/update',
  getInvoices:'/customers/services',
  CreateAddOnService:'/customers/services/add',
  requestBuyerId: 'customers/requestBuyerId',
  requestBuyerIdAgain: 'customers/requestBuyerIdAgain',
  getCustomerDropDown: 'customers/dropdown',
  getCustomerQueue: '/customers',
  getCustomerDetail: 'customers/details',
  getBuyerIdDetail: 'customers/buyerId/details',
  getBuyerIdByAuctionId: 'customers/request/details',
  verifyFinance: 'customers/verifyFinance',
  allocateBuyerId: 'customers/allocateBuyerId',
  deallocateBuyerId: 'customers/deallocateBuyerId',
  changeAllocationStatus: 'customers/changeAllocationStatus',
  getMessages: 'customers/messages',
  sendMessage: 'customers/sendMessage',
  getCustomerBooking: 'customers/booking',
  getCustomerBuyerId: 'customers/buyerIds',
  deleteId:'customers/removeAuctionHouse',
  getGalaxyCustomerList:'customers/galaxy',
  CreateMemo:'customers/sendMemo',
  CreateNotifcation:'customers/sendNotifications',
  ChangeBranch:'customers/updateBranch',
  ChangeType:'customers/updateTrustedStatus',
  CreateSubCustomer:'users/addSubCustomer',
  getSubCustomerList:'users/subCustomers',
  SelectCustomer:'vehicleBookings/update',
  getAgents:'/agents',
  addCustomer:'/customers/add',
  UpdateCustomer:'customers/update',
  AddVisa:'/visas/addRequest',
  VisaProcessing:'/visas/processing',
  getWPSList:'/customers/wps',
  UpdateWPStatus:'/customers/wps/update',
  CreateWPS:'/customers/wps/add',
  UpdateAddOnService:'/customers/services/update',
  getCandidateDetail:'/customers/candidates/details',
  CustomerStatus:'customers/updateStatus',
  DeleteVoucher:'/accounts/vouchers/delete',
  DeleteJournalVoucher:'/accounts/journalVouchers/delete',
  checkWPS:'/customers/wps/check',
  getRejectedVisa:'customers/candidates/rejected',
  UpdateCandidate:'customers/candidates/update',
  handleDeleteDraft:'visas/deleteDraft',
  handleDeleteCustomer:'/customers/delete',
  getCategoryList:'/services/categories',
  CreateCategory:'/services/categories/add',
  getServiceItem:"/services",
  AddServiceItem:"/services/add",
  UpdateServiceItem:"/services/update",
  DeleteServiceItem:"/services/delete",
  DetailServiceItem:"/services/details",

  getCategoryDetail:'/services/categories/details',
  UpdateCategory:'/services/categories/update',
  DeleteCategory:'',
  getReceptionDetail:'/sales/reception/details',
  getCompanies:'/customers/companies',
  addCompany:'/customers/companies/add',
  CreateReception:'/sales/reception/add',
  getReceptionsList:"/sales/reception",
  deleteReception:'/sales/reception/delete',
  UpdateReception:'/sales/reception/update',
  CreateBank:'/system/banks/add',
  getBanks:'/system/banks',
  DeleteBank:'/system/banks/delete',
  UpdateBank:'/system/banks/update',
  getBankDetail:'/system/banks/details',
  CreateSaleReceipt:'/sales/receipts/pre/add',
  getPreSales:'/sales/receipts',
  getInvoices:'/sales/receipts/paid',
  getPreSaleDetail:'/sales/receipts/details',
  DeletePreSale:'/sales/receipts/delete',
  UpdateSaleReceipt:'/sales/receipts/update',
  CreateAlDed:'/sales/receipts/place',
  getReceiptDetail:'/sales/receipts/details',
  CreateCard:'/system/cards/add',
  getCards:'/system/cards/',
  UpdateCard:'/system/cards/update',
  getInvoiceNumber:'/sales/receipts/invoiceNumber',
  getServiceReport:'/reports/serviceReport',
  getCollectionReport:'/reports/collectionReport',
  PayReceipt:'/sales/receipts/pay/v2',
  UpdateReceipt:'/sales/reception/update',
  CreditReceipt:'/sales/receipts/credit',
  getSystemSettings:'/system/settings',
  DeleteCustomerPayment:'payments/customer/delete',
  DeleteVendorPayment:'payments/vendor/delete',
  CreateCustomerPayment:'payments/customer/add',
  CreateVendorPayment:'payments/vendor/add',
  getServiceCategories:'/services/categories',
  getSnapshotCategoryReport:'/reports/snapshot/category',
  getSnapshotOverviewReport:'/reports/snapshot/overview',
  getVendors:'/vendors',
  deleteVendor:'/vendors/delete',
  CreateVendor:'/vendors/add',
  getVendorDetail:'/vendors/details',
  UpdateVendor:'/vendors/update',
  getCreditDebitToken:'/accounts/generateNumber',
  CreateNote:'/accounts/notes/add',
  getNotes:'/accounts/notes',
  deleteNotes:'/accounts/notes/delete',
  getCreditNoteInvoiceLedgers:'/accounts/notes/invoiceLedgers',
  getVoucherToken:'/accounts/generateNumber',
  getVouchers:'/accounts/vouchers',
  getProductCategory:'/products/categories',
  CreateProductCategory:'/products/categories/add',
  DeleteProductCategory:'/products/categories/delete',
  getProductCategoryDetail:'/products/categories/details',
  UpdateProductCategory:'/products/categories/update',
  getProducts:'/products',
  CreateProduct:'/products/add',
  DeleteProduct:'/products/delete',
  getProductDetail:'/products/details',
  getInventory:'products/inventory',
  UpdateProduct:'/products/update',
  CreatePurchaseInvoice:'/purchases/invoice/add',
  getPurchaseInvoices:'/purchases/invoice',
  getPurchaseInvoiceDetail:'/purchases/invoice/details',
  UpdatePurchaseInvoice:'/purchases/invoice/update',
  getPaymentInvoices:'/purchases/invoice/payments',
  getInvoicesPayments:'/purchases/invoice/specific/payments',
  getInvoiceNumberToken:'/purchases/invoice/number',
  getCostCenters:'system/costCenters',
  CreatePrepaidInvoices:'/purchases/prepaidExpenses/add',
  getPrepaidList:'/purchases/prepaidExpenses/',
  deletePrepaid:'/purchases/prepaidExpenses/delete',
  getPrepaidDetail:'/purchases/prepaidExpenses/details',
  UpdatePrepaidInvoices:'/purchases/prepaidExpenses/update',
  CreateFixedAssets:'/purchases/fixedAssets/add',
  UpdateFixedAssets:'/purchases/fixedAssets/update',
  getFixedAssets:'/purchases/fixedAssets/',
  getFixedAssetsDetail:'/purchases/fixedAssets/details',
  deleteFixedAssets:"/purchases/fixedAssets/delete",
  getEmployeeSalesReport:'/reports/employeeSalesSummary',
  getUnits:'products/inventory/units',
  unitStatusUpdate:'/products/inventory/units/mark',
  getPaymentVoucherDetail:'/accounts/vouchers/details',
  getFundTransferDetail:'accounts/iftVouchers/details',
  getEmployees:"/hrms/employees",
  getEmployeeDetail:'/hrms/employees/details',
  getDetailedCollectionReport:'Reports/detailedCollectionReport',
  CreateLeave:'/hrms/leaves/apply',
  getLeaves:'/hrms/leaves',
  UpdateLeave:'/hrms/leaves/update',
  LeaveStatus:'/hrms/leaves/process',
  adjustLeaves:'/hrms/leaves/adjust',
  CreateSaleReceipt2:'/sales/receipts/place/mohre',
  getVatReport:'/reports/vatRegister/Output',
  getVatInputReport:'/reports/vatRegister/Input',
  invoiceDateUpdate:'/sales/receipts/updateDate',
  handleVoid:'sales/invoice/void',
  getVoidReceipts:'/sales/receipts/payments',
  settledInvoiceData:'/payments/customer/receipts',
  RefundInvoice:'sales/receipts/refund',
  getPaidReceiptDetail:'sales/receipts/invoice/details',
  UpdatePaidReceipt:'sales/receipts/updatePaymentMethod',
  customerPaymentUpdate:'payments/customer/update',
  updateEmployeePassword:'/hrms/employees/changePassword',
  markAttendance:'/users/attendance/markManual',
  getHolidays:'/hrms/holidays',
  addHoliday:'/hrms/holidays/add',
  updateHoliday:'/hrms/holidays/update',
  deleteHoliday:'/hrms/holidays/delete',
  employeeSalaryDetail:'/hrms/payroll/calculate',
  getSalaries:'/hrms/payroll',
  updateSalaryStatus:'/hrms/payroll/updateStatus',
  getSalaryDetail:'/hrms/payroll/details',
  getShifts:'/hrms/shifts/',
  getInventoryLocations:'/products/inventory/locations',
  CreateLocation:'/products/inventory/locations/add',
  UpdateLocation:'/products/inventory/locations/update',
  getAgingReportReceivable:'/reports/aging/receivables',
  getAgingReportPayable:'/reports/aging/payables',
  getEmployeeLeaves:'/hrms/employees/leaves',
  PurchaseInvoiceSettlement:'/purchases/invoice/adjust',
  SalesInvoiceSettlement:'/sales/invoice/adjust',
  getSalesSettlement:'sales/invoice/adjustments',
  getPurchaseSettlement:'purchases/invoice/adjustments',
  getLeaveDetail:'/hrms/employees/leaves/details',
  getFP:"/purchases/FPinvoice",
  getFPPayments:'/purchases/FPinvoice/payments',
  getPaySlips:'/hrms/payslips',
  getRoutedShifts:'/hrms/shifts/roasterallocations',
  AllocateNewShift:'/hrms/shifts/allocate',
  CreateInvoiceDebitNote:'purchases/FPinvoice/debitNote/add',
  deleteInvoiceDebitNote:'purchases/FPinvoice/debitNote/delete',
  getHRStats:'hrms/stats',
  employeeEOSDetail:'hrms/eos/calculate',
  getEos:'hrms/eos',
  updateEOSStatus:'hrms/eos/updateStatus',
  getEOSDetail:'hrms/eos/details',
  getUserCategory:'users/profile',
  deleteLeave:'hrms/leaves/delete',
  deleteUser:'users/delete',
  getPrepaidInvoiceDetail:'/purchases/fpInvoice/details',
  VoidInvoice:'purchases/invoice/void',
  UpdateSaleReceipt2:'sales/receipts/update/paid'


};

export default routes